// Generate a URL for public assets that works in dev and in the built app,
// including when served from a subpath defined by PUBLIC_URL/homepage.
export function assetUrl(path: string): string {
  const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  const p = String(path || '').replace(/^\//, '');
  // If no PUBLIC_URL/base is set, return a relative path (no leading slash)
  return base ? `${base}/${p}` : p;
}
